import React, {Fragment, useEffect} from 'react'
import {Popover, PopoverButton, PopoverPanel, Transition} from '@headlessui/react'
import {Bars3Icon, XMarkIcon,} from '@heroicons/react/24/outline'
import {
    ArchiveBoxArrowDownIcon,
    ArchiveBoxIcon,
    ArrowLeftEndOnRectangleIcon, ArrowRightStartOnRectangleIcon,
    BanknotesIcon,
    CakeIcon,
    ChevronUpDownIcon,
    CreditCardIcon,
    CurrencyDollarIcon,
    GiftIcon,
    HomeIcon,
    MagnifyingGlassIcon,
    PencilIcon,
    QrCodeIcon,
    TagIcon,
    TicketIcon
} from '@heroicons/react/20/solid'
import {useNavigate} from "react-router-dom";
import {
    ADMIN_ROLE, clearVenueSession,
    DANCEPAY_ROLE,
    DRINKPAY_ROLE,
    EDITDANCER_ROLE,
    getLoginSession,
    getVenueSession,
    MOD_ROLE,
    PAYINVOICE_ROLE,
    PAYOUT_ROLE,
    SELL_ROLE,
    STAGEDISPLAY_ROLE,
    USER_ROLE
} from "../../requests/AppSession";
import {baseWebUrl} from "../../requests/NetworkRequestAuth0";
import {useAuth} from "@workos-inc/authkit-react";
import LogoutButton from "../login/auth0/LogoutButton";
import ThemeToggle from "../theme/ThemeToggle";

export default function Header({headerType}) {
    let navigate = useNavigate();


    const {isLoading, user} = useAuth();

    const [isLoggedIn, setIsLoggedIn] = React.useState(false);
    const [roles, setRoles] = React.useState([]);
    const [hasVenue, setHasVenue] = React.useState(false);
    const [privateDancePayFeatureFlag, setPrivateDancePayFeatureFlag] = React.useState(false);
    const [dancePayFeatureFlag, setDancePayFeatureFlag] = React.useState(false);
    const [drinkPayFeatureFlag, setDrinkPayFeatureFlag] = React.useState(false);
    const [stageTipFeatureFlag, setStageTipFeatureFlag] = React.useState(false);
    const [venueRewardsFeatureFlag, setVenueRewardsFeatureFlag] = React.useState(false);
    const [venueStripePaymentsFeatureFlag, setVenueStripePaymentsFeatureFlag] = React.useState(false);

    useEffect(() => {
        if (isLoading) {
            return;
        }

        if (user) {
            setIsLoggedIn(true);
        } else {
            navigate('/login/mobile', {replace: true});
        }

        getLoginSession().then(loginSession => {
            if (loginSession && loginSession.userId) {
                if (loginSession.roles) {
                    setRoles(loginSession.roles.split(","));
                    const checkRoles = loginSession.roles.split(",");
                    if (headerType === "AdminOnly") {
                        if (checkRoles && !checkRoles.includes(ADMIN_ROLE)) {
                            navigate('/login/mobile', {replace: true});
                        }
                    } else if (headerType === "AdminModeratorOnly") {
                        if (checkRoles && (!checkRoles.includes(ADMIN_ROLE) && !checkRoles.includes(MOD_ROLE))) {
                            navigate('/login/mobile', {replace: true});
                        }
                    } else if (headerType === "AdminPayoutOnly") {
                        if (checkRoles && (!checkRoles.includes(ADMIN_ROLE) && !checkRoles.includes(PAYOUT_ROLE))) {
                            navigate('/login/mobile', {replace: true});
                        }
                    } else if (headerType === "AdminSellOnly") {
                        if (checkRoles && (!checkRoles.includes(ADMIN_ROLE) && !checkRoles.includes(SELL_ROLE))) {
                            navigate('/login/mobile', {replace: true});
                        }
                    } else if (headerType === "AdminEditDancerOnly") {
                        if (checkRoles && (!checkRoles.includes(ADMIN_ROLE) && !checkRoles.includes(EDITDANCER_ROLE))) {
                            navigate('/login/mobile', {replace: true});
                        }
                    } else if (headerType === "AdminPayInvoiceOnly") {
                        if (checkRoles && (!checkRoles.includes(ADMIN_ROLE) && !checkRoles.includes(PAYINVOICE_ROLE))) {
                            navigate('/login/mobile', {replace: true});
                        }
                    } else if (headerType === "AdminDancePayOnly") {
                        if (checkRoles && (!checkRoles.includes(ADMIN_ROLE) && !checkRoles.includes(DANCEPAY_ROLE))) {
                            navigate('/login/mobile', {replace: true});
                        }
                    } else if (headerType === "AdminDrinkPayOnly") {
                        if (checkRoles && (!checkRoles.includes(ADMIN_ROLE) && !checkRoles.includes(DRINKPAY_ROLE))) {
                            navigate('/login/mobile', {replace: true});
                        }
                    } else if (headerType === "AdminStageDisplayOnly") {
                        if (checkRoles && (!checkRoles.includes(ADMIN_ROLE) && !checkRoles.includes(STAGEDISPLAY_ROLE))) {
                            navigate('/login/mobile', {replace: true});
                        }
                    } else if (headerType === "UserOnly") {
                        if (checkRoles && !checkRoles.includes(USER_ROLE)) {
                            navigate('/login/mobile', {replace: true});
                        }
                    }
                }

                setIsLoggedIn(true);
            } else {
                navigate('/login/mobile', {replace: true});
            }
        })

        getVenueSession().then(venueSession => {
            if (venueSession && venueSession.venueId && venueSession.venueId !== null) {
                setHasVenue(true);
            } else {
                setHasVenue(false);
            }

            if (venueSession) {
                setPrivateDancePayFeatureFlag(venueSession.privateDancePayFeatureFlag);
                setDancePayFeatureFlag(venueSession.dancePayFeatureFlag);
                setDrinkPayFeatureFlag(venueSession.drinkPayFeatureFlag);
                setStageTipFeatureFlag(venueSession.stageTipFeatureFlag);
                setVenueRewardsFeatureFlag(venueSession.venueRewardsFeatureFlag);
                setVenueStripePaymentsFeatureFlag(venueSession.venueStripePaymentsFeatureFlag);
            } else {
                setPrivateDancePayFeatureFlag(false);
                setDancePayFeatureFlag(false);
                setDrinkPayFeatureFlag(false);
                setStageTipFeatureFlag(false);
                setVenueRewardsFeatureFlag(false);
                setVenueStripePaymentsFeatureFlag(false);
            }
        })

        return function cleanup() {

        };
    }, [isLoading]);

    return (
        <Popover className="relative bg-white dark:bg-gray-900">
            <div className="flex items-center justify-between px-4 py-6 sm:px-6 md:justify-start md:space-x-10">
                <div className="flex justify-start lg:w-0 lg:flex-1 md:w-0 md:flex-1">
                    <a onClick={() => {
                        navigate('/');
                    }}>
                        <span className="sr-only">VirtualTipz</span>
                        <img
                            className="block dark:hidden cursor-pointer h-8 w-auto sm:h-10"
                            src={baseWebUrl + "/VirtualTipzLogo.png"}
                            alt="VirtualTipzLogo"
                        />
                        <img
                            className="hidden dark:block cursor-pointer h-8 w-auto sm:h-10"
                            src={baseWebUrl + "/VirtualTipzLogoDark.png"}
                            alt="VirtualTipzLogo"
                        />
                    </a>
                </div>
                <div className="-my-2 -mr-2">
                    <PopoverButton
                        className="inline-flex items-center justify-center rounded-md bg-white dark:bg-gray-800 p-2 text-gray-400 dark:text-gray-500 hover:bg-gray-100 dark:hover:bg-gray-800 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-pink-500">
                        <span className="sr-only">Open menu</span>
                        <Bars3Icon className="h-6 w-6" aria-hidden="true"/>
                    </PopoverButton>
                </div>
            </div>

            <Transition
                as={Fragment}
                enter="duration-200 ease-out"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="duration-100 ease-in"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
            >
                <PopoverPanel focus
                              className="absolute z-10 inset-x-0 top-0 origin-top-right transform p-2 transition">
                    <div
                        className="divide-y-2 divide-gray-50 dark:divide-gray-700 rounded-lg bg-white dark:bg-gray-800 shadow-lg ring-1 ring-black ring-opacity-5">
                        <div className="px-5 pt-5 pb-6">
                            <div className="flex items-center justify-between">
                                <div>
                                    <img
                                        className="block dark:hidden h-8 w-auto"
                                        src={baseWebUrl + "/VirtualTipzLogo.png"}
                                        alt="VirtualTipzLogo"
                                    />
                                    <img
                                        className="hidden dark:block h-8 w-auto"
                                        src={baseWebUrl + "/VirtualTipzLogoDark.png"}
                                        alt="VirtualTipzLogo"
                                    />
                                </div>
                                <div className="-mr-2">
                                    <PopoverButton
                                        className="inline-flex items-center justify-center rounded-md bg-white dark:bg-gray-800 p-2 text-gray-400 dark:text-gray-500 hover:bg-gray-100 dark:hover:bg-gray-800 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-pink-500">
                                        <span className="sr-only">Close menu</span>
                                        <XMarkIcon className="h-6 w-6" aria-hidden="true"/>
                                    </PopoverButton>
                                </div>
                            </div>
                            <div className="mt-6">
                                <nav className="grid grid-cols-1 gap-7">
                                    {roles?.includes(USER_ROLE) &&
                                        <>
                                            {hasVenue && stageTipFeatureFlag && <a
                                                onClick={() => {
                                                    navigate('/stage');
                                                }}
                                                className="-m-3 cursor-pointer flex items-center rounded-lg p-3 hover:bg-gray-50 dark:hover:bg-gray-800"
                                            >
                                                <div
                                                    className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-md bg-pink-400 text-white">
                                                    <CakeIcon className="h-6 w-6" aria-hidden="true"/>
                                                </div>
                                                <div className="ml-4 text-base font-medium text-gray-900 dark:text-gray-100">The Stage
                                                </div>
                                            </a>}
                                            <a
                                                onClick={() => {
                                                    navigate('/user/code');
                                                }}
                                                className="-m-3 cursor-pointer flex items-center rounded-lg p-3 hover:bg-gray-50 dark:hover:bg-gray-800"
                                            >
                                                <div
                                                    className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-md bg-pink-400 text-white">
                                                    <QrCodeIcon className="h-6 w-6" aria-hidden="true"/>
                                                </div>
                                                <div className="ml-4 text-base font-medium text-gray-900 dark:text-gray-100">User Code
                                                </div>
                                            </a>
                                            {hasVenue && venueRewardsFeatureFlag && <a
                                                onClick={() => {
                                                    navigate('/user/rewards');
                                                }}
                                                className="-m-3 cursor-pointer flex items-center rounded-lg p-3 hover:bg-gray-50 dark:hover:bg-gray-800"
                                            >
                                                <div
                                                    className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-md bg-pink-400 text-white">
                                                    <GiftIcon className="h-6 w-6" aria-hidden="true"/>
                                                </div>
                                                <div className="ml-4 text-base font-medium text-gray-900 dark:text-gray-100">My Rewards
                                                </div>
                                            </a>}


                                            {hasVenue && <div className="text-s/6 font-semibold text-gray-400 dark:text-gray-500">Buy</div>}

                                            {hasVenue && <a
                                                onClick={() => {
                                                    navigate('/user/buy');
                                                }}
                                                className="-m-3 cursor-pointer flex items-center rounded-lg p-3 hover:bg-gray-50 dark:hover:bg-gray-800"
                                            >
                                                <div
                                                    className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-md bg-pink-400 text-white">
                                                    <CurrencyDollarIcon className="h-6 w-6" aria-hidden="true"/>
                                                </div>
                                                <div className="ml-4 text-base font-medium text-gray-900 dark:text-gray-100">Buy
                                                    VirtualTipz
                                                </div>
                                            </a>}
                                            {hasVenue && (privateDancePayFeatureFlag || dancePayFeatureFlag) && <a
                                                onClick={() => {
                                                    navigate('/dance/buy');
                                                }}
                                                className="-m-3 cursor-pointer flex items-center rounded-lg p-3 hover:bg-gray-50 dark:hover:bg-gray-800"
                                            >
                                                <div
                                                    className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-md bg-pink-400 text-white">
                                                    <TicketIcon className="h-6 w-6" aria-hidden="true"/>
                                                </div>
                                                <div className="ml-4 text-base font-medium text-gray-900 dark:text-gray-100">Buy Dance
                                                </div>
                                            </a>}
                                            {hasVenue && drinkPayFeatureFlag && <a
                                                onClick={() => {
                                                    navigate('/drink/buy');
                                                }}
                                                className="-m-3 cursor-pointer flex items-center rounded-lg p-3 hover:bg-gray-50 dark:hover:bg-gray-800"
                                            >
                                                <div
                                                    className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-md bg-pink-400 text-white">
                                                    <TagIcon className="h-6 w-6" aria-hidden="true"/>
                                                </div>
                                                <div className="ml-4 text-base font-medium text-gray-900 dark:text-gray-100">Buy Drink
                                                </div>
                                            </a>}

                                            {hasVenue && <div className="text-s/6 font-semibold text-gray-400 dark:text-gray-500">History</div>}

                                            {hasVenue && stageTipFeatureFlag && <a
                                                onClick={() => {
                                                    navigate('/user/tip/history');
                                                }}
                                                className="-m-3 cursor-pointer flex items-center rounded-lg p-3 hover:bg-gray-50 dark:hover:bg-gray-800"
                                            >
                                                <div
                                                    className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-md bg-pink-400 text-white">
                                                    <ArchiveBoxIcon className="h-6 w-6" aria-hidden="true"/>
                                                </div>
                                                <div className="ml-4 text-base font-medium text-gray-900 dark:text-gray-100">Tip History
                                                </div>
                                            </a>}
                                            {hasVenue && (privateDancePayFeatureFlag || dancePayFeatureFlag) && <a
                                                onClick={() => {
                                                    navigate('/user/dance/history');
                                                }}
                                                className="-m-3 cursor-pointer flex items-center rounded-lg p-3 hover:bg-gray-50 dark:hover:bg-gray-800"
                                            >
                                                <div
                                                    className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-md bg-pink-400 text-white">
                                                    <ArchiveBoxArrowDownIcon className="h-6 w-6" aria-hidden="true"/>
                                                </div>
                                                <div className="ml-4 text-base font-medium text-gray-900 dark:text-gray-100">Dance History
                                                </div>
                                            </a>}
                                            {hasVenue && drinkPayFeatureFlag && <a
                                                onClick={() => {
                                                    navigate('/user/drink/history');
                                                }}
                                                className="-m-3 cursor-pointer flex items-center rounded-lg p-3 hover:bg-gray-50 dark:hover:bg-gray-800"
                                            >
                                                <div
                                                    className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-md bg-pink-400 text-white">
                                                    <ArchiveBoxArrowDownIcon className="h-6 w-6" aria-hidden="true"/>
                                                </div>
                                                <div className="ml-4 text-base font-medium text-gray-900 dark:text-gray-100">Drink History
                                                </div>
                                            </a>}
                                            <a
                                                onClick={() => {
                                                    navigate('/user/buy/history');
                                                }}
                                                className="-m-3 cursor-pointer flex items-center rounded-lg p-3 hover:bg-gray-50 dark:hover:bg-gray-800"
                                            >
                                                <div
                                                    className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-md bg-pink-400 text-white">
                                                    <ArchiveBoxArrowDownIcon className="h-6 w-6" aria-hidden="true"/>
                                                </div>
                                                <div className="ml-4 text-base font-medium text-gray-900 dark:text-gray-100">
                                                    Purchase History
                                                </div>
                                            </a>

                                            {hasVenue && <div className="flex items-center">
                                                <div aria-hidden="true" className="w-full border-t border-gray-300 dark:border-white/15" />
                                                <div className="relative flex justify-center">
                                                    <span className="bg-white px-2 text-sm text-gray-500 dark:bg-gray-900 dark:text-gray-400"></span>
                                                </div>
                                                <div aria-hidden="true" className="w-full border-t border-gray-300 dark:border-white/15" />
                                            </div>}

                                            <a
                                                onClick={() => {
                                                    navigate('/user/virtualtipz');
                                                }}
                                                className="-m-3 cursor-pointer flex items-center rounded-lg p-3 hover:bg-gray-50 dark:hover:bg-gray-800"
                                            >
                                                <div
                                                    className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-md bg-pink-400 text-white">
                                                    <BanknotesIcon className="h-6 w-6" aria-hidden="true"/>
                                                </div>
                                                <div className="ml-4 text-base font-medium text-gray-900 dark:text-gray-100">
                                                    VirtualTipz
                                                </div>
                                            </a>

                                            {hasVenue ?
                                                <a
                                                    onClick={() => {
                                                        clearVenueSession();
                                                        navigate('/find');
                                                    }}
                                                    className="-m-3 cursor-pointer flex items-center rounded-lg p-3 hover:bg-gray-50 dark:hover:bg-gray-800"
                                                >
                                                    <div
                                                        className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-md bg-pink-400 text-white">
                                                        <ArrowRightStartOnRectangleIcon className="h-6 w-6" aria-hidden="true"/>
                                                    </div>
                                                    <div className="ml-4 text-base font-medium text-gray-900 dark:text-gray-100">Check-out Club
                                                    </div>
                                                </a>
                                                : <a
                                                onClick={() => {
                                                    navigate('/find');
                                                }}
                                                className="-m-3 cursor-pointer flex items-center rounded-lg p-3 hover:bg-gray-50 dark:hover:bg-gray-800"
                                            >
                                                <div
                                                    className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-md bg-pink-400 text-white">
                                                    <MagnifyingGlassIcon className="h-6 w-6" aria-hidden="true"/>
                                                </div>
                                                <div className="ml-4 text-base font-medium text-gray-900 dark:text-gray-100">Check-in Club
                                                </div>
                                            </a>}
                                        </>
                                    }
                                    {roles && roles.includes(ADMIN_ROLE) &&
                                        <>
                                            <a
                                                onClick={() => {
                                                    navigate('/');
                                                }}
                                                className="-m-3 cursor-pointer flex items-center rounded-lg p-3 hover:bg-gray-50 dark:hover:bg-gray-800"
                                            >
                                                <div
                                                    className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-md bg-pink-400 text-white">
                                                    <HomeIcon className="h-6 w-6" aria-hidden="true"/>
                                                </div>
                                                <div className="ml-4 text-base font-medium text-gray-900 dark:text-gray-100">
                                                    Dashboard
                                                </div>
                                            </a>
                                        </>
                                    }
                                    {roles && (roles.includes(SELL_ROLE) || roles.includes(ADMIN_ROLE)) &&
                                        <>
                                            <a
                                                onClick={() => {
                                                    navigate('/sell');
                                                }}
                                                className="-m-3 cursor-pointer flex items-center rounded-lg p-3 hover:bg-gray-50 dark:hover:bg-gray-800"
                                            >
                                                <div
                                                    className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-md bg-pink-400 text-white">
                                                    <CreditCardIcon className="h-6 w-6" aria-hidden="true"/>
                                                </div>
                                                <div className="ml-4 text-base font-medium text-gray-900 dark:text-gray-100">
                                                    Sell VirtualTipz
                                                </div>
                                            </a>
                                        </>
                                    }
                                    {roles && (roles.includes(DANCEPAY_ROLE) || roles.includes(ADMIN_ROLE)) && (privateDancePayFeatureFlag || dancePayFeatureFlag) &&
                                        <>
                                            <a
                                                onClick={() => {
                                                    navigate('/dance/sell');
                                                }}
                                                className="-m-3 cursor-pointer flex items-center rounded-lg p-3 hover:bg-gray-50 dark:hover:bg-gray-800"
                                            >
                                                <div
                                                    className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-md bg-pink-400 text-white">
                                                    <TicketIcon className="h-6 w-6" aria-hidden="true"/>
                                                </div>
                                                <div className="ml-4 text-base font-medium text-gray-900 dark:text-gray-100">
                                                    Sell Dance
                                                </div>
                                            </a>
                                        </>
                                    }
                                    {roles && (roles.includes(DRINKPAY_ROLE) || roles.includes(ADMIN_ROLE)) && drinkPayFeatureFlag &&
                                        <>
                                            <a
                                                onClick={() => {
                                                    navigate('/drink/sell');
                                                }}
                                                className="-m-3 cursor-pointer flex items-center rounded-lg p-3 hover:bg-gray-50 dark:hover:bg-gray-800"
                                            >
                                                <div
                                                    className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-md bg-pink-400 text-white">
                                                    <TagIcon className="h-6 w-6" aria-hidden="true"/>
                                                </div>
                                                <div className="ml-4 text-base font-medium text-gray-900 dark:text-gray-100">
                                                    Sell Drink
                                                </div>
                                            </a>
                                        </>
                                    }
                                    {roles && (roles.includes(MOD_ROLE) || roles.includes(ADMIN_ROLE)) &&
                                        <>
                                            {stageTipFeatureFlag && <a
                                                onClick={() => {
                                                    navigate('/selection');
                                                }}
                                                className="-m-3 cursor-pointer flex items-center rounded-lg p-3 hover:bg-gray-50 dark:hover:bg-gray-800"
                                            >
                                                <div
                                                    className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-md bg-pink-400 text-white">
                                                    <ChevronUpDownIcon className="h-6 w-6" aria-hidden="true"/>
                                                </div>
                                                <div className="ml-4 text-base font-medium text-gray-900 dark:text-gray-100">Dancer
                                                    Selection
                                                </div>
                                            </a>}
                                        </>
                                    }
                                    {roles && (roles.includes(PAYOUT_ROLE) || roles.includes(ADMIN_ROLE)) &&
                                        <>
                                            {(stageTipFeatureFlag || privateDancePayFeatureFlag || dancePayFeatureFlag) &&
                                                <a
                                                    onClick={() => {
                                                        navigate('/payout');
                                                    }}
                                                    className="-m-3 cursor-pointer flex items-center rounded-lg p-3 hover:bg-gray-50 dark:hover:bg-gray-800"
                                                >
                                                    <div
                                                        className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-md bg-pink-400 text-white">
                                                        <CurrencyDollarIcon className="h-6 w-6" aria-hidden="true"/>
                                                    </div>
                                                    <div className="ml-4 text-base font-medium text-gray-900 dark:text-gray-100">Dancer
                                                        Payout
                                                    </div>
                                                </a>}
                                        </>
                                    }
                                    {roles && (roles.includes(EDITDANCER_ROLE)) &&
                                        <>
                                            <a
                                                onClick={() => {
                                                    navigate('/venue/dancer/edit');
                                                }}
                                                className="-m-3 cursor-pointer flex items-center rounded-lg p-3 hover:bg-gray-50 dark:hover:bg-gray-800"
                                            >
                                                <div
                                                    className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-md bg-pink-400 text-white">
                                                    <PencilIcon className="h-6 w-6" aria-hidden="true"/>
                                                </div>
                                                <div className="ml-4 text-base font-medium text-gray-900 dark:text-gray-100">Add/Edit
                                                    Dancer
                                                </div>
                                            </a>
                                        </>
                                    }
                                    {roles && (roles.includes(PAYINVOICE_ROLE)) &&
                                        <>
                                            <a
                                                onClick={() => {
                                                    navigate('/venue/invoice');
                                                }}
                                                className="-m-3 cursor-pointer flex items-center rounded-lg p-3 hover:bg-gray-50 dark:hover:bg-gray-800"
                                            >
                                                <div
                                                    className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-md bg-pink-400 text-white">
                                                    <BanknotesIcon className="h-6 w-6" aria-hidden="true"/>
                                                </div>
                                                <div className="ml-4 text-base font-medium text-gray-900 dark:text-gray-100">View Invoices
                                                </div>
                                            </a>
                                        </>
                                    }
                                    {roles && (roles.includes(STAGEDISPLAY_ROLE) || roles.includes(ADMIN_ROLE)) && stageTipFeatureFlag &&
                                        <>
                                            <a
                                                onClick={() => {
                                                    navigate('/stage/display');
                                                }}
                                                className="-m-3 cursor-pointer flex items-center rounded-lg p-3 hover:bg-gray-50 dark:hover:bg-gray-800"
                                            >
                                                <div
                                                    className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-md bg-pink-400 text-white">
                                                    <CakeIcon className="h-6 w-6" aria-hidden="true"/>
                                                </div>
                                                <div className="ml-4 text-base font-medium text-gray-900 dark:text-gray-100">The Stage
                                                </div>
                                            </a>
                                        </>
                                    }
                                    {isLoggedIn ?
                                        // <a
                                        //     onClick={() => {
                                        //         const navToUserLogin = roles && roles.includes(USER_ROLE) && roles.length === 1;
                                        //         logOutSession().then(() => {
                                        //             setIsLoggedIn(false);
                                        //             if (navToUserLogin) {
                                        //                 navigate('/login/mobile');
                                        //             } else {
                                        //                 navigate('/admin');
                                        //             }
                                        //         })
                                        //     }}
                                        //     className="-m-3 cursor-pointer flex items-center rounded-lg p-3 hover:bg-gray-50"
                                        // >
                                        //     <div
                                        //         className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-md bg-pink-400 text-white">
                                        //         <ArrowRightEndOnRectangleIcon className="h-6 w-6" aria-hidden="true"/>
                                        //     </div>
                                        //     <div className="ml-4 text-base font-medium text-gray-900 dark:text-gray-100">Logout</div>
                                        // </a>
                                        <LogoutButton/>
                                        :
                                        <a
                                            onClick={() => {
                                                navigate('/login/mobile');
                                            }}
                                            className="-m-3 cursor-pointer flex items-center rounded-lg p-3 hover:bg-gray-50 dark:hover:bg-gray-800"
                                        >
                                            <div
                                                className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-md bg-pink-400 text-white">
                                                <ArrowLeftEndOnRectangleIcon className="h-6 w-6" aria-hidden="true"/>
                                            </div>
                                            <div className="ml-4 text-base font-medium text-gray-900 dark:text-gray-100">Login</div>
                                        </a>
                                    }
                                    {isLoggedIn &&
                                        <a
                                            onClick={() => {
                                                navigate('/legal');
                                            }}
                                            className="-m-3 cursor-pointer flex items-center justify-center rounded-lg p-3 hover:bg-gray-50 dark:hover:bg-gray-800"
                                        >
                                            <div className="text-sm font-normal text-gray-500 dark:text-gray-400">Terms &amp; Privacy
                                            </div>
                                        </a>
                                    }
                                    <div className="border-t border-gray-200 pt-4 dark:border-gray-700">
                                        <ThemeToggle/>
                                    </div>
                                </nav>
                            </div>
                        </div>
                    </div>
                </PopoverPanel>
            </Transition>
        </Popover>
    )
}
